export const DEFAULT_VEHICLE_STATE = {
    pagination: {},
    vehicles: [],
    vehicle: {},
    loading: false,
    error: null,
    count: 0,
};
